import React, { useState, useEffect } from "react";
import GuestLayout from "../../../layouts/GuestLayout";
import Hero from "../../../components/landing/Hero";
import WhatWeOffer from "../../../components/landing/WhatWeOffer";
import HowItWorks from "../../../components/landing/HowItWorks";
import Images from "../../../utils/Images";
import SubscriptionPackages from "../../../components/landing/SubscriptionPackages";
import { toast } from "react-toastify";
import Loader from "../../../components/utilities/Loader";
import Testimonials from "../../../components/landing/Testimonials";
import Faq from "../../../components/landing/Faq";
import landingPageRequests from "../../../api/Guest/LandingPageRequests";
import EnterpriseSolutionSection from "../../../components/landing/EnterpriseSolutionSection";
import { modifyPackagePrices } from "../../../utils/packageUtils";
const Landing = () => {
  const [subscriptionPackages, setSubscriptionPackages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSubscriptionPackages = async () => {
      try {
        setIsLoading(true);
        const response = await landingPageRequests.getSubscriptionPlans();
        // //console.log("Subscription Plans Response:", response?.data?.data);
        if (response.data.status_code === "000") {
          const modifiedPackages = modifyPackagePrices(response.data.data);
          setSubscriptionPackages(modifiedPackages);
          // //console.log("Fetched Packages:", response.data.data);
        } else {
          toast.error(response.data.reason);
        }
      } catch (error) {
        toast.error(error.response.data.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchSubscriptionPackages();
  }, []);

  // //console.log(subscriptionPackages);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <GuestLayout>
      <Hero />
      <WhatWeOffer />
      <HowItWorks imageUrl={Images.how_it_works_img} />
      <SubscriptionPackages packages={subscriptionPackages} />
      
      {/* Enterprise Solution Section */}
      <EnterpriseSolutionSection />

      <Testimonials />
      <Faq />
    </GuestLayout>
  );
};

export default Landing;
